import { CallAPIAction, Status } from 'api/types'
import { PayNoticeResponse } from 'api/evisaAPI/noticesAPI'
import { PayfortBill } from 'common/types/transformedRespTypes'
import Actions from 'redux/actions'

type State = {
  status?: boolean
  bill?: PayfortBill
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  params: undefined,
  url: undefined,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.PAY_NOTICE_ASYNC,
    Actions.PAY_NOTICE_SUCCESS,
    Actions.PAY_NOTICE_FAIL,
    PayNoticeResponse
  >,
): State => {
  switch (action.type) {
    case Actions.PAY_NOTICE_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        status: payload.status,
        bill: {
          params: payload.bill.params,
          url: payload.bill.url,
        },
      }
    }
    case Actions.PAY_NOTICE_ASYNC:
    case Actions.PAY_NOTICE_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
